// extracted by mini-css-extract-plugin
export var accessDesktop = "footer-module--accessDesktop--b8366";
export var accordionWrapper = "footer-module--accordionWrapper--38eae";
export var addressDesktop = "footer-module--addressDesktop--3c590";
export var buttonsWrapper = "footer-module--buttonsWrapper--8af6a";
export var legalsWrapper = "footer-module--legalsWrapper--6ac6f";
export var logosWrapper = "footer-module--logosWrapper--6a4ad";
export var socialsWrapper = "footer-module--socialsWrapper--33821";
export var title = "footer-module--title--cdbb9";
export var wrapper = "footer-module--wrapper--0877b";